/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const iconStyle = {
  container: {
    lineHeight: 0,
  },
  bordered: (theme: Theme) => ({
    padding: "0.375rem",
    border: `1px solid ${theme.palette.primary.light}`,
    borderRadius: "0.5rem",
    backgroundColor: theme.palette.primaryPale,
  }),
  borderedActive: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  }),
};
